import { render } from "./costSetting.vue?vue&type=template&id=6738a2d8"
import script from "./costSetting.vue?vue&type=script&lang=js"
export * from "./costSetting.vue?vue&type=script&lang=js"

import "./costSetting.vue?vue&type=style&index=0&id=6738a2d8&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__